<template>
  <el-header class="bg-theme">
    <div class="h-full flex items-center justify-between">
      <img src="/img/dygc-logo.png" width="108px" alt="logo" />
      <slot name="right-button"></slot>
    </div>
  </el-header>
</template>

<script>
export default {
  name: 'PcHeader'
}
</script>
